export default "/img/MV.76ec7e7678559e8be904e54c41af9c97.png";